import { Directive, HostListener, Input } from '@angular/core';
import { WizardService } from './wizard.service';

// <button [goToStep]="2">Ir al paso 3</button>
@Directive({
	selector: '[pgsGoToStep]'
})
export class GoToStepDirective {

	@Input() goToStep: number;

	constructor(private wizardService: WizardService) { }

	@HostListener('click')
	onClick(): void {
		this.wizardService.goToStep(this.goToStep);
	}
}
